module.exports = __webpack_public_path__ + "static/media/solano_shadow.9ce8c53c.png";